import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export default class WFPCheckout {
    /**
     * Fetch merchant signature for WayForPay checkout
     * @param merchantAccount - Merchant account name
     * @param merchantDomainName - Merchant domain name
     * @param orderReference - Unique order reference
     * @param orderDate - UNIX timestamp as a string
     * @param amount - Total amount for the transaction
     * @param currency - Currency of the transaction (e.g., "UAH")
     * @param productName - Array of product names
     * @param productCount - Array of product counts
     * @param productPrice - Array of product prices
     * @returns Signature for WayForPay checkout
     */
    public static async getSignature(
        merchantAccount: string,
        merchantDomainName: string,
        orderReference: string,
        orderDate: string,
        amount: number,
        currency: string,
        productName: string[],
        productCount: number[],
        productPrice: number[]
    ): Promise<string | undefined> {
        try {
            const response = await axios.post(
                `${environment.api_url}/checkout/sign`,
                {
                    merchantAccount,
                    merchantDomainName,
                    orderReference,
                    orderDate,
                    amount,
                    currency,
                    productName,
                    productCount,
                    productPrice,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200 && response.data?.signature) {
                return response.data.signature;
            } else {
                console.error("Failed to fetch signature:", response.data);
                return undefined;
            }
        } catch (error) {
            console.error("Error fetching signature:", error);
            return undefined;
        }
    }
}
